export class GitHubConstants {
    public static readonly FILE: string = 'file';
    public static readonly DIR: string = 'dir';
    public static readonly TOKEN_STORAGE_KEY: string = 'github.token';
    public static readonly GITHUB_TOKEN_VALIDATION: RegExp = /^[-A-Za-z0-9_]{40,}$/;
    public static readonly GITHUB_HOST_VALIDATION: RegExp = /https:\/\/.+/;
    public static readonly TREE = 'tree';
    public static readonly BLOB = 'blob';
    public static readonly TREE_MODE = '040000';
    public static readonly BLOB_MODE = '100644';
    public static readonly GITHUB_HOST = 'https://github.com';
    public static readonly GITHUB_API_ENDPOINT = 'https://api.github.com';
    public static readonly GITHUB_GRAPHQL_FILES_BATCH_SIZE = 100;

    public static readonly GITHUB_AUTHORIZE_URL: string = 'https://github.com/login/oauth/authorize?scope=repo &client_id={0}&state={1}';
    public static readonly PROVIDER: string = 'GitHub';
    public static readonly GITHUB_ACCESS_TOKEN_BASE_URL = 'https://github.com/login/oauth/access_token';
    public static readonly GITHUB_LOCAL_TEST_CLIENT_ID = '5917daa93358e1727c78';
    public static readonly GITHUB_WS_LOCAL_TEST_CLIENT_ID = 'bd5e595d122577243fee';
    public static readonly GITHUB_CI_CLIENT_ID = 'e2ab8508d27ef8e8f7c6';
    public static readonly GITHUB_WS_CI_CLIENT_ID = 'f0db00f78df95149eb93';
    public static readonly GITHUB_STAGING_CLIENT_ID = 'cce7bbe81b6ecfdf2f8a';
    public static readonly GITHUB_WS_STAGING_CLIENT_ID = '9e8b50f4f4fb2e11f929';
    public static readonly GITHUB_MS_INTERNAL_CLIENT_ID = '3cc524e7839a8c0fdf84';
    public static readonly GITHUB_WS_MS_INTERNAL_CLIENT_ID = 'da037b986415933d2348';
    public static readonly GITHUB_PRODUCTION_CLIENT_ID = '954afc65e8507f42da0f';
    public static readonly GITHUB_WS_PRODUCTION_CLIENT_ID = '75a841cca32f4e51e9bc';
    public static readonly GITHUB_FAIRFAX_TEST_CLIENT_ID = 'f007d6e1890a0fa31ebd';
    public static readonly GITHUB_FAIRFAX_PRODUCTION_CLIENT_ID = 'c699a7abae95b73f2deb';
    public static readonly GITHUB_MOONCAKE_TEST_CLIENT_ID = '';
    public static readonly GITHUB_MOONCAKE_PRODUCTION_CLIENT_ID = '';
    public static readonly GITHUB_USNAT_TEST_CLIENT_ID = '';
    public static readonly GITHUB_USNAT_PRODUCTION_CLIENT_ID = '';
    public static readonly GITHUB_USSEC_TEST_CLIENT_ID = '';
    public static readonly GITHUB_USSEC_PRODUCTION_CLIENT_ID = '';
}
